import { getExpressAPIHost } from '../../../../utils';
import { convertParamsToAQPQueryString } from './utils';

const buildExpressBulkQuery = (endpoint, { params }) => {
    return {
        url: `${getExpressAPIHost() + endpoint}/body-query/`,
        body: { query: convertParamsToAQPQueryString(params) },
    };
};

export default buildExpressBulkQuery;
